import axios from '@/utils/request'
import base from '@/api/base'

/**
 * 工单（/v1/tickets/**）
 */

export function listTickets(params) {
  return axios.get(`${base.url}/service/v1/tickets`, { params })
}

export function getTicket(id) {
  return axios.get(`${base.url}/service/v1/tickets/${id}`)
}

export function createTicket(ticket) {
  return axios.post(`${base.url}/service/v1/tickets`,
    JSON.stringify(ticket), { headers: { 'Content-Type': 'application/json' } })
}

export function assignTicket(id, assigneeId) {
  return axios.post(`${base.url}/service/v1/tickets/${id}/assign`,
    JSON.stringify({ assigneeId }), { headers: { 'Content-Type': 'application/json' } })
}

export function resolveTicket(id) {
  return axios.post(`${base.url}/service/v1/tickets/${id}/resolve`)
}

export function closeTicket(id) {
  return axios.post(`${base.url}/service/v1/tickets/${id}/close`)
}